import { motion } from 'framer-motion';

const MobileFooter = ({ content, activeTab, handleIconClick, language }) => {
    return (
        <div className="w-full md:hidden flex justify-center">
            <div
                className="relative w-[200px] h-[300px] rounded-2xl px-4 overflow-hidden"
                style={{
                    backgroundImage: `url('/footer-mobile-bg.png')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            >
                {/* İçerik */}
                <div className="relative z-10 h-full flex flex-col">
                    {/* Başlık */}
                    <p className="text-[#3032D4] font-extrabold text-center mr-[50px] mt-[40px] mb-2">
                        {language === 'fa' ? 'ارتباط با ما' : 'Contact Us'}
                    </p>

                    {/* Butonlar */}
                    <div className="flex flex-col gap-1.5 items-end mr-[13px] mb-2">
                        {content.call?.phoneNumbers?.length > 0 && (
                            <button
                                onClick={() => handleIconClick('call')}
                                className={`flex items-center justify-center gap-1 px-2 rounded-md text-[10px] font-bold transition-all w-[92px] h-[25px] ${activeTab === 'call'
                                    ? 'bg-[#F7BD5F] text-[#204286] shadow-md'
                                    : 'bg-white/80 text-[#204286]'
                                    }`}
                            >
                                <img src='/call.svg' alt="" className="w-3 h-3" />
                                {language === 'fa' ? 'خطوط ارتباطی' : 'Contact'}
                            </button>
                        )}
                        {content.office?.addresses?.length > 0 && (
                            <button
                                onClick={() => handleIconClick('office')}
                                className={`flex items-center justify-center text-[10px] gap-1 px-2 rounded-md font-bold transition-all w-[92px] h-[25px] ${activeTab === 'office'
                                    ? 'bg-[#F7BD5F] text-[#204286] shadow-md'
                                    : 'bg-white/80 text-[#204286]'
                                    }`}
                            >
                                <img src='/office.svg' alt="" className="w-3 h-3" />
                                {language === 'fa' ? 'دفاتر شرکت' : 'Offices'}
                            </button>
                        )}
                        {content.social?.items?.length > 0 && (
                            <button
                                onClick={() => handleIconClick('social')}
                                className={`flex items-center justify-center text-[10px] gap-1 px-2 rounded-md font-bold transition-all w-[92px] h-[25px] ${activeTab === 'social'
                                    ? 'bg-[#F7BD5F] text-[#204286] shadow-md'
                                    : 'bg-white/80 text-[#204286]'
                                    }`}
                            >
                                <img src='/social.svg' alt="" className="w-3 h-3" />
                                {language === 'fa' ? 'فضای مجازی' : 'Social'}
                            </button>
                        )}
                    </div>

                    {/* Bilgiler */}
                    <motion.div
                        className="flex-1 flex items-center justify-center px-3"
                        key={activeTab}
                        initial={{ opacity: 0, y: 5 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        {/* Call içeriği */}
                        {activeTab === 'call' && content.call?.phoneNumbers?.length > 0 && (
                            <div className="space-y-1 text-center">
                                {content.call.phoneNumbers.map((phone, idx) => (
                                    <p key={idx} className="phone-number text-[#204286] text-[9px] font-extrabold" dir="ltr">
                                        {phone}
                                    </p>
                                ))}
                                {content.call.international && (
                                    <div className="mt-1 pt-1 border-t border-gray-200">
                                        <p className="text-[#3032D4] text-[8px] font-extrabold">
                                            {content.call.international.label}
                                        </p>
                                        <p className="phone-number text-[#204286] text-[9px] font-extrabold mt-0.5" dir="ltr">
                                            {content.call.international.number}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Office içeriği */}
                        {activeTab === 'office' && content.office?.addresses?.length > 0 && (
                            <div className="space-y-1 text-center">
                                {content.office.addresses.map((item, idx) => (
                                    <div key={idx}>
                                        {item.isInternational ? (
                                            <p className="text-[#3032D4] text-[8px] font-extrabold leading-tight mb-0.5">
                                                {item.address}
                                            </p>
                                        ) : (
                                            item.url ? (
                                                <a
                                                    href={item.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="block text-[#204286] text-[8px] font-extrabold leading-tight border-b border-gray-200 pb-1 last:border-0"
                                                >
                                                    {item.address}
                                                </a>
                                            ) : (
                                                <p className="text-[#204286] text-[8px] font-extrabold leading-tight border-b border-gray-200 pb-1 last:border-0">
                                                    {item.address}
                                                </p>
                                            )
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Social içeriği */}
                        {activeTab === 'social' && content.social?.items?.length > 0 && (
                            <div className="space-y-1.5">
                                {content.social.items.map((item, idx) => (
                                    <a
                                        key={idx}
                                        href={item.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-center justify-end gap-1.5 cursor-pointer hover:opacity-80 transition-opacity"
                                    >
                                        <p className="text-[#204286] text-[8px] font-extrabold truncate max-w-[120px]">
                                            {item.title}
                                        </p>
                                        <img src={item.icon} alt="" className="w-4 h-4" />
                                    </a>
                                ))}
                            </div>
                        )}

                        {/* Boş durum */}
                        {activeTab === 'call' && content.call?.phoneNumbers?.length === 0 && (
                            <p className="text-[#204286] text-[9px]">
                                {language === 'fa' ? 'اطلاعاتی موجود نیست' : 'No data'}
                            </p>
                        )}
                        {activeTab === 'office' && content.office?.addresses?.length === 0 && (
                            <p className="text-[#204286] text-[9px]">
                                {language === 'fa' ? 'اطلاعاتی موجود نیست' : 'No data'}
                            </p>
                        )}
                        {activeTab === 'social' && content.social?.items?.length === 0 && (
                            <p className="text-[#204286] text-[9px]">
                                {language === 'fa' ? 'اطلاعاتی موجود نیست' : 'No data'}
                            </p>
                        )}
                    </motion.div>
                </div>
            </div>
        </div>
    );
};

export default MobileFooter;